import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'custom-editor',
  templateUrl: './custom-editor.component.html'
})
export class CustomEditorComponent {
  value?: any;
  @Input() parentForm: FormGroup = new FormGroup({});
  @Input() nameInput: string = 'nameInput';
  @Input() placeholder?: string;

  @Input()
  set ngValue(value: any) {
    this.value = value;
    this.ngValueChange.emit(this.value);
  }

  @Output()
  ngValueChange = new EventEmitter<any>();

  get ngValue() {
    return this.value;
  }
}
